import pdfjsLib from 'pdfjs-dist';
import sleep from 'sleep-promise';
import { toastr } from 'react-redux-toastr';
import _ from 'lodash';
import Moment from 'moment';
import $ from 'jquery';
import glp from 'google-libphonenumber';
import { browserHistory } from 'react-router';
import numberToWords from 'number-to-words';
import JSZip from 'jszip';
import Docxtemplater from 'docxtemplater';
import InspectModule from './InspectModule';
import { caseSavingNeededAction,
         casesRefreshNeededAction,
         caseSetServerError,
         caseSetCurrentAction,
         caseRefreshAction,
         caseEditIdAction
       } from '../actions/caseActions';

import { isSavingNeeded,
         isEmptyString,
         isEmptyObject } from '../validators/formValidators';

import { matterPartialFormSaveAction } from '../actions/formActions';
import { userNotificationsAction,
         userTaskUpdateAction } from '../actions/userActions';
import { comparisonTypes } from '../components/common/FilterSearchField';
import { getDefaultFilterEntry } from '../components/common/FilterSearchForm';
import { getCountry } from './internationalization';


const POSSIBLE_DATETIME_FORMATS = [`${process.env.DATE_FORMAT} HH:mm`, process.env.DATE_FORMAT];

export const SINGLE_SMS_LENGTH = parseInt(process.env.SINGLE_SMS_LENGTH, 10);
export const MAX_SMS_LENGTH = SINGLE_SMS_LENGTH * parseInt(process.env.MAX_SMS_UNITS_PER_MESSAGE, 10);
export const MAX_UNITS_PER_MONTH = parseInt(process.env.MAX_UNITS_PER_MONTH, 10);

export const convertPhoneNumberToUS_E164 = (phone) => {
    let phoneUtil = glp.PhoneNumberUtil.getInstance();
    let phoneNumber = phoneUtil.parse(phone, 'US');
    let e164 = phoneUtil.format(phoneNumber, glp.PhoneNumberFormat.E164);
    return e164;
};

export const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

export const matterPartialFormSavePromise = (dispatch, id, data, setCurrentCase = true) => {
    return new Promise((resolve, reject) => {
        if (isNaN(id)) {
            let error = 'Unexpected: invalid id provided';
            console.error(new Error().stack, error);
            reject(error);
            return;
        }

        data.id = id;
        dispatch(matterPartialFormSaveAction(data))
            .then((result) => {
                if (result) {
                    const savedCase = result.data.currentCase;
                    if (setCurrentCase) {
                        dispatch(caseSetCurrentAction(savedCase));
                    }

                    dispatch(casesRefreshNeededAction(true));
                    resolve(result);
                } else {
                    reject(false);
                }
            })
            .catch((error) => {
                console.error(new Error().stack, error);
                dispatch(caseSetServerError(error));
                reject(error);
            });
    });
};

export const retrieveNotifications = (dispatch) => {
    dispatch(userNotificationsAction())
        .catch((error) => {
            console.error(new Error().stack, error);
            sleep(process.env.CLIENT_POLLING_INTERVAL_MILISECONDS).then((result) => {
                retrieveNotifications(dispatch);
            });
        });
};

export const formComponentWillReceiveProps = (props, nextProps) => {
    let savingNeeded = isSavingNeeded(props,
                                      nextProps,
                                      props.savingNeeded,
                                      nextProps.savingNeeded);

    if (savingNeeded) {
        props.dispatch(caseSavingNeededAction(savingNeeded));
    }
};


export const getWorkflowTranslationHashTable = (config, currentCase, extraData = {}, filter = undefined, returnArray = false, sourceConfigTable = 'workflow', defaultSections = {client: 'Client', intake: 'Case'} ) => {
    let data = {};
    let dataArray = [];
    let workflow;
    if (isEmptyObject(config)) {
        if (returnArray) {
            return [];
        }

        return extraData;
    }

    if (isEmptyObject(currentCase)) {
        currentCase = {};
    }
    
    if (!currentCase.intake) {
        currentCase.intake = {};
    }

    let currentIntakeSection = defaultSections.intake;
    let currentClientSection = defaultSections.client;
    for (let i = 0; i < config[sourceConfigTable].length; i++) {
        workflow = config[sourceConfigTable][i];
        if (filter && !filter(workflow.type, undefined, undefined)) {
            continue;
        }

        const length = workflow && workflow.tables.length;
        for (let i = length - 1; i >= 0; i--) {
            for (let j = 0; j < workflow.tables[i].fields.length; j++) {
                const table = workflow.tables[i].table;
                const field = {...workflow.tables[i].fields[j]};
                const fieldName = field.name;
                let skip = false;
                if (field.type === 'Separator') {
                    if (table === 'intake') {
                        currentIntakeSection = field.props.label;
                    } else if (table === 'client') {
                        currentClientSection = field.props.label;
                    }

                    skip = true;
                }

                if (filter && !filter(workflow.type, table, field)) {
                    continue;
                }

                let value = '';
                const label = field.props && field.props.label;
                switch (table) {
                case 'me':
                    value = field.value;
                    switch (fieldName) {
                    case 'FirstName':
                    case 'LastName':
                    case 'CompanyName':
                    case 'CompanyHash':
                    case 'PracticeState':
                    case 'Country':
                    case 'Email':
                    case 'Phone':
                    case 'Timezone':
                        break;
                    default:
                        skip = true;
                        break;
                    }

                    break;

                case 'extra':
                    switch (fieldName) {
                    case 'ClientFullName':
                        if (!isEmptyObject(currentCase) && currentCase.client) {
                            value = getFullName(currentCase.client);
                        }

                        break;

                    case 'ClientFullNameShort':
                        if (!isEmptyObject(currentCase) && currentCase.client) {
                            let client = { ...currentCase.client };
                            if (!isEmptyString(client['MiddleName']) &&
                                client['MiddleName'].length > 0) {

                                client['MiddleName'] = `${client['MiddleName'].charAt(0)}.`;
                            }

                            value = getFullName(client);
                        }

                        break;

                    // Server must convert UTC time to timezone used by the user to get the proper user date.
                    case 'DateToday':
                        if (__CLIENT__) {
                            value = Moment.utc().format(process.env.DATE_FORMAT);
                        } else {
                            skip = true;
                        }

                        break;

                    case 'MonthToday':
                        if (__CLIENT__) {
                            value = Moment.utc().format('M');
                        } else {
                            skip = true;
                        }

                        break;

                    case 'MonthNameToday':
                        if (__CLIENT__) {
                            value = Moment.utc().format('MMMM');
                        } else {
                            skip = true;
                        }

                        break;

                    case 'DayToday':
                        if (__CLIENT__) {
                            value = Moment.utc().format('D');
                        } else {
                            skip = true;
                        }

                        break;

                    case 'YearToday':
                        if (__CLIENT__) {
                            value = Moment.utc().format('YYYY');
                        } else {
                            skip = true;
                        }

                        break;
    

                    default:
                        console.error(`Unknown field: ${table}.${fieldName}`);
                        break;
                    }

                    break;

                case 'payment':
                    if (currentCase && currentCase[table] && currentCase[table][fieldName]) {
                        value = currentCase[table][fieldName];
                    }
 
                    break;

                default:
                    if (currentCase && currentCase[table] && currentCase[table][fieldName]) {
                        value = getTextValue(currentCase[table][fieldName]);
                    }

                    break;
                }

                if (!skip) {
                    if (!value) {
                        value = '';
                    }

                    if (field.type === 'Contact') {
                        let contact = {};
                        try {
                            contact = JSON.parse(value);

                        } catch(e) {
                            // Ignore string and empty values.
                        }

                        if (config.client && field.props) {
                            for (let i = 0; i < config.client.length; i++) {
                                if (config.client[i].type === field.props['clientType']) {
                                    let clientFields = config.client[i].tables[0].fields;
                                    for (let j = 0; j < clientFields.length; j++) {
                                        if (clientFields[j].type === 'ClientType') {
                                            continue;
                                        }

                                        data[`${table}.${fieldName}.${clientFields[j].name}`] = contact[clientFields[j].name];
                                        const fieldTmp = { ...field };
                                        fieldTmp.name = `${fieldName}.${clientFields[j].name}`;
                                        fieldTmp.value = contact[clientFields[j].name];
                                        fieldTmp.table = table;
                                        fieldTmp.nested = true;
                                        fieldTmp.placeholder = `{${table}.${fieldName}.${clientFields[j].name}}`;
                                        if (table === 'intake') {
                                            fieldTmp.section = currentIntakeSection;
                                        } else if (table === 'client') {
                                            fieldTmp.section = currentClientSection;
                                        }

                                        if (filter && !filter(workflow.type, table, fieldTmp)) {
                                            continue;
                                        }

                                        dataArray.push(fieldTmp);
                                    }

                                    data[`${table}.${fieldName}`] = contact['$Label$'];
                                    field.value = contact['$Label$'];
                                    field.table = table;
                                    field.label = label;
                                    field.placeholder = `{${table}.${fieldName}}`;
                                    if (table === 'intake') {
                                        field.section = currentIntakeSection;
                                    } else if (table === 'client') {
                                        field.section = currentClientSection;
                                    }

                                    dataArray.push(field);
                                    break;
                                }
                            }
                        }
                    } else {
                        data[`${table}.${fieldName}`] = value;
                        field.value = value;
                        field.table = table;
                        field.label = label;
                        if (table === 'intake') {
                            field.section = currentIntakeSection;
                        } else if (table === 'client') {
                            field.section = currentClientSection;
                        }

                        field.placeholder = `{${table}.${fieldName}}`;
                        dataArray.push(field);
                    }
                }
            }

            if (!data['intake.AssignedTo'] && config && config['employeesMapping']) {
                const customField = {
                    name: 'AssignedTo',
                    value: config['employeesMapping'][currentCase['intake']['AssignedTo']],
                    table: 'intake',
                    label: 'Case Manager',
                    placeholder: '{intake.AssignedTo}'
                };

                if (filter && !filter(workflow.type, 'intake', customField)) {
                    continue;
                }

                data['intake.AssignedTo'] = config['employeesMapping'][currentCase['intake']['AssignedTo']];
                dataArray.push(customField);
            }
        }
    }

    if (returnArray) {
        return dataArray;
    }

    // replace values in data with values in extra data, if there is an overlap
    Object.keys(data).forEach((key) => {
        if (extraData[key]) {
            data[key] = extraData[key];
        }
    });

    // put the extra variables first
    data = {...extraData, ...data};
    return data;
};

export const getPublicLawPayAccount = (account) => {
    let result = {};
    if (account) {
        result = {
            "id": account["id"],
            "name": account["name"],
            "type": account["type"],
            "currency": account["currency"],
            "public_key": account["public_key"],
            "trust_account": account["trust_account"]
        };
    }

    return result;
};

export const isDemoAccount = loggedIn => {
    return loggedIn && loggedIn['$Subscription$'] && loggedIn['$Subscription$'].demo;
}

export const getPublicUserData = (user) => {
    // Ensure that all values are strings or undefined, 
    // update getWorkflowTranslationHashTable as well.
    const toPublic = (user) => {
        let userPublic = undefined;
        if (user) {
            const gmailAccount = !isEmptyString(user['GmailToken']) ? 'true' : undefined;
            const outlookAccount = !isEmptyString(user['OutlookToken']) ? 'true' : undefined;
            const gdriveAccount = !isEmptyString(user['GDriveToken']) ? 'true' : undefined;
            const oneDriveAccount = !isEmptyString(user['OneDriveToken']) ? 'true' : undefined;
            const driveId = (gdriveAccount || oneDriveAccount) ? user['DriveId']: undefined;
            const driveRootFolder = (gdriveAccount || oneDriveAccount) ? user['DriveRootFolder']: undefined;
            userPublic = {
                "id": user['id'],
                "owner_id": user['owner_id'],
                "created_at": user['created_at'],
                "deleted_at": user['deleted_at'],
                "updated_at": user['updated_at'],
                "FirstName": user['FirstName'],
                "LastName": user['LastName'],
                "CompanyName": user['CompanyName'],
                "CompanyHash": user['CompanyHash'],
                "PracticeState": user['PracticeState'],
                "Country": getCountry(user),
                "Email": user['Email'],
                "Phone": user['Phone'],
                "Timezone": user['Timezone'],
                "TwoFactorAuth": user['TwoFactorAuth'],
                "$Subscription$": user['$Subscription$'],
                "LawPayAccount": getPublicLawPayAccount(user['LawPayAccount']),
                "PayPalAccount": user['PayPalAccount'],
                "GmailAccount": gmailAccount,
                "GmailCalendarId": user['GmailCalendarId'],
                "EmailReadEnabled": user['EmailReadEnabled'] ? 'true' : undefined,
                "Theme": user['Theme'],
                "MailboxAddress": (gmailAccount || outlookAccount) ? user['MailboxAddress'] : undefined,
                "GDriveAccount": gdriveAccount,
                "OutlookAccount": outlookAccount,
                "OneDriveAccount": oneDriveAccount,
                "DriveId": driveId,
                "DriveRootFolder": driveRootFolder,
                "welcomeTourDone": user['welcomeTourDone'],
                "casesTourDone": user['casesTourDone'],
                "caseTourDone": user['caseTourDone'],
                "PublicSmsPhone": user['PublicSmsPhone'],
                "SubscriptionApiKey": user['SubscriptionApiKey']
            };
        }

        return userPublic;
    };

    if (_.isArray(user)) {
        return user.map(u => {
            return toPublic(u);
        });

    } else {
        return toPublic(user);
    }
};

export const getPubliIntakeLinkForCaseType = (caseType, user, addLabel = false) => {
    return getPublicIntakeFormLinkExtraData(
        {publicIntakeHash: `?q=${encodeURIComponent(caseType)}`},
        user,
        addLabel)['extra.PublicIntakeLink'];
}

export const getPublicIntakeFormLinkExtraData = (currentCase, user, addLabel = false) => {
    if (!user || !user['CompanyHash']) {
        return {};
    }

    let publicIntakeHash = '';
    if (currentCase && currentCase.publicIntakeHash) {
        publicIntakeHash = `/${currentCase.publicIntakeHash}`;
    }

    let url = __DOMAIN_NAME__;
    let publicIntakeLink = `${url}/intake/${user['CompanyHash']}${publicIntakeHash}`;
    let result = {};
    result['extra.PublicIntakeLink'] = publicIntakeLink;
    if (addLabel) {
        if (addLabel) {
            result['extra.PublicIntakeLink'] = {
                label: 'Intake Form Link',
                value: result['extra.PublicIntakeLink'],
            };
        }
    }

    return result;
};

export const getPublicSigningUrl = (hash) => {
    if (hash) {
        return `${__DOMAIN_NAME__}/sign/${hash.hash}`;

    } else {
        return '[ Document Website HTTP Link ]'
    }
};


export const getSignDocumentInfo = (hash) => {
    const key = `${hash.signDocument}_${hash.hash}.pdf`;
    const templateKey = `${hash.hash}_${hash.signDocument}`;
    const path = `${hash.ownerId}/case/${hash.caseId}/signed_docs/${key}`;
    const templateFolder = 'document/signed_docs';
    const templatePath = `${hash.ownerId}/template/${templateFolder}/${templateKey}`;
    const sourceTemplatePath = `${hash.ownerId}/template/document/${hash.signDocument}`;
    const name = hash.signDocument;
    return {
        key,
        path,
        templateKey,
        templatePath,
        templateFolder,
        sourceTemplatePath,
        name,
    };
};

export const getPublicPaymentUrl = (hash) => {
    if (hash) {
        return `${__DOMAIN_NAME__}/pay/${hash.hash || hash['$PublicHash$']}`;

    } else {
        return '[ Payment Website HTTP Link ]'
    }
};


export const getFeeInWords = (currentCase, field = 'Fee') => {
    let feeInWordsValue = '';
    if (!isEmptyObject(currentCase) && currentCase.payment) {
        try {
            feeInWordsValue = numberToWords.toWords(currentCase.payment[field]);
        } catch(error) {
            feeInWordsValue = '';
        }
    }

    return feeInWordsValue;
}

export const getExtraData = (currentCase, config, user, addLabel = false) => {
    const publicIntakeLinks = getPublicIntakeFormLinkExtraData(currentCase, user, addLabel);
    let signatureValue = '[ Client signature will be inserted here ]';
    let signatureSmallValue = '[ Smaller client signature will be inserted here ]';
    let signatureLinkValue = '[ HTTP Link for newly created signing website ]';
    let paymentLinkValue = '[ HTTP Link for newly created payment website ]';
    let signatureDateTimeValue = '[ Client date and time of signature will be inserted here ]';
    if (addLabel) {
        signatureValue = {
            label: 'Document client signature placeholder',
            value: signatureValue,
        };

        signatureSmallValue = {
            label: 'Document client signature small placeholder',
            value: signatureValue,
        };

        signatureDateTimeValue = {
            label: 'Document client signature date time',
            value: signatureDateTimeValue,
        };

        signatureLinkValue = {
            label: 'Document client signature HTTP link',
            value: signatureLinkValue,
        };

        paymentLinkValue = {
            label: 'Payment HTTP link',
            value: paymentLinkValue,
        };
    }
    
    const extraData = {
        ...publicIntakeLinks,
        'payment.PaymentLink': paymentLinkValue,
        '%docs.Signature': signatureValue,
        '%docs.Signature_Small': signatureSmallValue,
        'docs.SignatureDateTime': signatureDateTimeValue,
        'docs.SignatureLink': signatureLinkValue,
        'docs.DocumentLink': signatureLinkValue,
    };

    return extraData;
};

export const transformTextFromPlaceholderMapping = (text, data, onNotFound = undefined) => { // throws
    if (!text) {
        return '';
    }

    let translatedText = '';
    for (let i = 0; i < text.length;) {
        let chr = text.charAt(i);
        if (chr != '{') {
            translatedText += chr;

        } else {
            let variable = '';
            let openBracket = ++i;
            for (; (i < text.length) && (text.charAt(i) != '}'); i++) {
                variable += text.charAt(i);
            }

            if (i >= text.length) {
                console.error(`Unclosed tag for variable ${variable}`);
                i = openBracket;
                continue;
            }

            const variableWithBrackets = `{${variable}}`;
            if (data[variable]) {
                translatedText += data[variable] || '';
            }
            else if (data[variableWithBrackets]) {
                translatedText += data[variableWithBrackets] || '';
            } else if (onNotFound) {
                onNotFound(variableWithBrackets);
            }
        }

        i++;
    }

    return translatedText;
}

export const transformText = (text, config, currentCase, extraData = undefined) => { // throws
    if (!text) {
        return '';
    }

    if (!extraData) {
        extraData = {};
    }

    let data = getWorkflowTranslationHashTable(config, currentCase, extraData);
    if (_.isArray(text)) {
        text = text.map(t => transformTextFromPlaceholderMapping(t, data));
        return text;
    }
    return transformTextFromPlaceholderMapping(text, data);
};

export const compareValuesByName = (a, b) => {
    if (a && !b) {
        return a;
    } else if (!a && b) {
        return b;

    } else if (a['Name'] == b['Name']) {
        return 0;

    } else if (a['Name'] < b['Name']) {
        return -1;

    } else {
        return 1;
    }
};

export const getFullName = (client) => {
    if (!client) {
        return '';
    }

    let firstName = client['FirstName'];
    let middleName = client['MiddleName'];
    let lastName = client['LastName'];
    let fullName = "";
    if (!isEmptyString(firstName)) {
        fullName = firstName + " ";
    }

    if (!isEmptyString(middleName)) {
        fullName += middleName + " ";
    }

    if (!isEmptyString(lastName)) {
        fullName += lastName;
    }

    return fullName;
};


export const getTextValue = (value) => {
    if (!value) {
        return value;
    }

    if (_.isString(value)) {
        return value;
    }

    if (_.isObject(value)) {
        if (value.value) {
            return value.value;
        }

        if (value.label) {
            return value.label;
        }

        return "";
    }

    return JSON.stringify(value);
};

export const getParameterByName = (name, url) => {
    if (!url) return null;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
};

export const getTemplateFromValue = (propsTemplates, name, templateSource) => {
    let template = undefined;
    if (!propsTemplates) {
        return template;
    }

    let templates = propsTemplates[templateSource];
    if (templates) {
        template = templates.find(value => value.fileName === getTextValue(name));
    }

    return template;
};

export const getCouponInfo = (coupon, price) => {
    let duration = '';
    let result = undefined;
    switch (coupon.duration) {
    case 'once':
        duration = 'one time';
        break;

    case 'forever':
        duration = 'forever';
        break;

    case 'repeating':
        duration = `${coupon.duration_in_months} month(s)`;
        break;

    default:
        console.error('Unexpected coupon duration type');
        return result;
    }

    if (coupon.amount_off) {
        let amount = parseInt(coupon.amount_off, 10);
        result = {
            finalPrice: parseInt(price - amount, 10),
            couponDescription: `Discount: $${amount / 100.0}, Duration: ${duration}.`
        };

    } else if (coupon.percent_off) {
        let percentage = parseFloat(coupon.percent_off);
        result = {
            finalPrice: Math.ceil((1.0 - (percentage / 100.0)) * price),
            couponDescription: `Discount: ${percentage}%, Duration: ${duration}.`
        };

    } else {
        console.error('Unexpected coupon discount type');
    }

    return result;
};

export const getStripeAdjustedPrice = (cost) => {
    cost += parseInt(process.env.STRIPE_FIXED_CHARGE_CENTS, 10);
    cost += Math.ceil(process.env.STRIPE_PERCENT_CHARGE * cost);
    return cost;
};

export const replaceFileExtension = (fileName, newExtension) => {
    let convertedFileName = fileName.substr(0, fileName.lastIndexOf('.')) + `.${newExtension}`;
    return convertedFileName;
};

export const getFileExtension = (fileName) => {
    return fileName.split('.').pop();
};

// OAuth2 utils

export const oauth2ClientPopup = (promise, onPopup, onSuccess, onError, authSuccess, authError, onAuthRequested = undefined) => {
    promise.then((result) => {
        if (!result) {
            onError('EMPTY_RESPONSE');
            return;
        }

        let popupBlockedError = () => {
            onError('Please allow popup windows.\nThere is typically an icon in the address bar\nwhere you can click to enable the popup.');
        };

        switch (result.data.type) {
        case 'AUTHORIZATION':
            if (onAuthRequested && !onAuthRequested()) {
                return;
            }
            let authUrl = result.data.authUrl;
            let popup = window.open(authUrl, 'popup', 'toolbar=0,status=0,width=500,height=500');
            if(!popup || popup.closed || typeof popup.closed == 'undefined') {
                 popupBlockedError();

            } else {
                onPopup(popup);
                try {
                    popup.focus();
                    const toastrOptions = {
                        timeOut: 15000, // by setting to 0 it will prevent the auto close
                        showCloseButton: true, // true by default
                        removeOnHover: true,
                        progressBar: true,
                    };

                    let timer = setInterval(() =>
                        {
                            try {
                                if (popup.document.title == 'SUCCESS') {
                                    clearInterval(timer);
                                    popup.close();
                                    onSuccess();
                                    toastr.success('Success', authSuccess, toastrOptions);
                                    return;

                                } else if (popup.document.title == 'ERROR') {
                                    clearInterval(timer);
                                    popup.close();
                                    onError('AUTH_FAILED');
                                    toastr.error('Authentication', authError, toastrOptions);
                                    return;
                                }

                             } catch (error) {}

                            if (popup.closed) {
                                clearInterval(timer);
                                onError('AUTH_FAILED');
                                toastr.error('Authentication', authError, toastrOptions);
                            }
                        },
                        500);

                } catch(error) {
                    popupBlockedError();
                }
            }

            break;

        case 'SUCCESS':
            onSuccess(result);
            break;

        default:
            onError('Invalid result type.');
            break;
        }

    })
    .catch((error) => {
        onError(error);
    });
}

export const replaceFieldsInConfig = (config, type, table, fields, configSource = 'workflow') => {
    let currentConfig = _.cloneDeep(config);
    if (!isEmptyString(type) &&
        currentConfig) {

        let fieldSource = currentConfig[configSource].find((value) => {return value['type'] === type;});
        if (fieldSource && fieldSource.tables) {
            let targetTableIndex = fieldSource.tables.findIndex((value) => {return value['table'] === table;});
            fieldSource.tables[targetTableIndex].fields = _.cloneDeep(fields);
        }
    }

    return currentConfig;
}

export const isValidSubscriptionStatus = (userPrivate) => {
    let valid = userPrivate &&
                userPrivate['$Subscription$'] &&
                (userPrivate['$Subscription$'].status === 'active' ||
                userPrivate['$Subscription$'].status === 'trialing');

    return valid;
}

// returns field[], field[i] = { name, label, type }
export const getFields = (config, asMap = false, table = 'workflow') => {
    let fields = [];
    let fieldSet = {};
    let workflow;
    let fieldsMap = {};
    if (isEmptyObject(config)) {
        if (asMap) {
            return fieldsMap;
        }

        return fields;
    }

    for (let i = 0; i < config[table].length; i++) {
        workflow = config[table][i];
        for (let i = 0; workflow && i < workflow.tables.length; i++) {
            for (let j = 0; j < workflow.tables[i].fields.length; j++) {
                let table = workflow.tables[i].table;
                let tableField = workflow.tables[i].fields[j];
                let name = `${table}.${tableField.name}`;
                let type = tableField.type;
                if (!type) {
                    type = 'Hidden';
                }

                let propsLabel = '';
                if (tableField.props && tableField.props.label) {
                    propsLabel = tableField.props.label;
                }

                const field = {
                    name,
                    type,
                    propsLabel,
                    label: `${propsLabel} (${name})`
                };

                if (fieldSet[field.name]) {
                    continue;
                }

                fieldSet[field.name] = true;
                fields.push(field);
                fieldsMap[field.name] = field;
            }
        }
    }

    if (table === 'client' && !fieldSet['client.ClientType']) {
        const field = {
            name: 'client.ClientType',
            type: 'ClientType',
            propsLabel: 'Contact Type',
            label: 'Contact Type (client.ClientType)',
        };

        fieldSet[field.name] = true;
        fields.push(field);
        fieldsMap[field.name] = field;
    }

    if (table === 'workflow' && !fieldSet['intake.CaseType']) {
        const field = {
            name: 'intake.CaseType',
            type: 'CaseType',
            propsLabel: 'Case Type',
            label: 'Case Type (intake.CaseType)',
        };

        fieldSet[field.name] = true;
        fields.push(field);
        fieldsMap[field.name] = field;
    }

    if (asMap) {
        return fieldsMap;
    }

    return fields;
};

export const parseFilterFromQuery = (filterQuery, archived, config, dbTable = 'matter', dbParams = []) => {
    let comparisonOps = comparisonTypes.map(comparisonOp => {
        return `${comparisonOp.value}`;

    }).reduce((a, b) => {
        return `${a}|${b}`;
    });

    comparisonOps = `(${comparisonOps})`;
    let fieldRe = /([a-zA-Z0-9]+)\.([a-zA-Z0-9]+)/;
    let valueRe = /((?:[^\\]*?(?:\\\)|\\\\)*(?:[^\\]*?)*?))/;
    let expression = '\\(' + fieldRe.source + ' ' + comparisonOps + ' ' + valueRe.source + '\\)';
    let finalRe = new RegExp('(?: (and|or) )?' + expression, 'g');
    let fields = [];
    if (dbTable === 'matter') {
        fields = getFields(config, false, 'workflow');
    } else {
        fields = getFields(config, false, 'client');
    }

    let tokens = finalRe.exec(filterQuery);
    if (!tokens || tokens.length == 0) {
        const result = { ...getDefaultFilterEntry() };
        if (archived) {
            result.archived = archived;
            return result;
        }

        if (filterQuery === '') {
            return result;
        } 

        return undefined;
    }

    let dbQuery = '';
    let type = '';
    let table = '';
    let name = '';
    let value = '';
    let comparisonOp = '';
    let filters = [];
    let filterType = '';
    for (let filterNo = 0; tokens; tokens = finalRe.exec(filterQuery), filterNo++) {
        let field;
        let fieldType;
        for (let type = 1; type < tokens.length; type++) {
            let token = tokens[type];
            if (token === undefined) {
                continue;
            }

            switch (type) {
            case 1:
                dbQuery += ` ${token} `;
                if (!filterType) {
                    filterType = token;

                } else if (filterType !== token) {
                    return undefined;
                }

                filterType = token;
                break;

            case 2: // table
                table = token;
                break;

            case 3: // field name
                name = token;
                field = fields.find(field => field.name == `${table}.${name}`);
                if (!field)
                {
                    return undefined;
                }

                fieldType = field

                break;

            case 4: // comparison operation
                comparisonOp = token;
                break;

            case 5: // value
                if (!token && comparisonOp != '_' && comparisonOp != '!_') {
                    return undefined;
                }

                value = token.replace('\\', '\\\\').replace(/\)/, '\\)');
                let comparison = comparisonTypes.find((comparison) => {
                    return comparison.value == comparisonOp;
                });

                fieldType = fieldType.type;
                if (field.name === 'intake.CreatedDate' || fields.name === 'client.CreatedDate') {
                    fieldType = 'DateTime';
                }

                dbQuery += comparison.db(dbTable, dbParams, fieldType, table, name, value);
                filters.push({
                    operator: comparisonOp,
                    left: `${table}.${name}`,
                    right: value
                });

                break;


            default:
                debugger
                assert(false);
                break;
            }
        }
    }

    return {
        dbQuery,
        dbParams,
        filters,
        type: filterType,
        archived
    };
};

export const convertFilterToQuery = (filterObj) => {
    if (!filterObj || !filterObj.filters || filterObj.filters.length == 0) {
        return '';
    }

    let query = '';
    for (let i = 0; i < filterObj.filters.length; i++) {
        let filter = filterObj.filters[i];
        if (query !== '') {
            query += ` ${filterObj.type} `
        }

        let value = filter.right.replace(/([^\\])[\\]/g, '$1\\\\').replace(/([^\\])[)]/g, '$1\\)').replace(/([^\\])[(]/g, '$1\\(');
        query += `(${filter.left} ${filter.operator} ${value})`;
    }

    return query;
};

export const filteredRoute = (baseUrl, filterObj) => {
    let route = baseUrl;
    let first = true;
    if (filterObj) {
        let filter = '';
        let query = '';
        if (filterObj.query || filterObj.query === '') {
            route += '?';
            first = false;
            route += 'q=' + encodeURIComponent(filterObj.query);
        }

        if (filterObj.filters) {
            if (first) {
                route += '?';
                first = false;

            } else {
                route += '&';
            }

            route += 'f=' + encodeURIComponent(convertFilterToQuery(filterObj.filters));
            if (filterObj.filters.archived) {
                route += '&a=' + encodeURIComponent(filterObj.filters.archived);
            }
        }
    }

    if (filterObj && filterObj.hideFilterPanel !== undefined) {
        let value = filterObj.hideFilterPanel;
        if (value === undefined) {
            if (filterObj && filterObj.filters) {
                value = false;
            } else {
                value = true;
            }
        }

        if (first) {
            route += '?';
            first = false;

        } else {
            route += '&';
        }

        route += 'hideFilterPanel=';
        route += encodeURIComponent(value);
    }


    return route;
};

export const makePromise = (thisPtr, fun, ...args /* arguments to pass excluding callback*/) => {
    return new Promise((resolve, reject) => {
        let callback = (err, result) => {
            if (err) {
                reject(err);
                return;
            }

            resolve(result);
        };

        args.push(callback);
        fun.apply(thisPtr, args);
    });
};

export const getLocalDateTimeFromIso = (user, date, withTime = true ) => {
    if (!date) {
        return '';
    }

    const timezone = user && user['Timezone'];
    if (timezone) {
        date = Moment.utc(date).tz(timezone);

    } else {
        date = Moment.utc(date);
    }

    let format = process.env.DATE_FORMAT;
    if (withTime) {
        format += ' HH:mm';
    }

    date = date.format(format);
    return date;
};


export const getTodayDateTZ = (user = undefined, asString = true, withTime = false, asStringFormat = undefined) => {
    let timezone = user && user['Timezone'];
    let date;
    if (timezone) {
        date = Moment.utc().tz(timezone);

    } else {
        date = Moment.utc();
    }

    if (asString) {
        let format;
        if (asStringFormat)  {
            format = asStringFormat;
        } else {
            format = process.env.DATE_FORMAT;
            if (withTime) {
                format += ' HH:mm';
            }
        }

        date = date.format(format);
    }

    return date;
};

export const getDateFromUTC = (date) => {
    if (!date) {
        return '';
    }

    return Moment.utc(date).format(process.env.DATE_FORMAT);
};

export const formatDate = (date) => {
    if (!date) {
        return '';
    }

    return Moment(date).format(process.env.DATE_FORMAT);
};


export const formatDateTime = (date) => {
    if (!date) {
        return '';
    }

    return Moment(date).format(process.env.DATE_FORMAT + ' HH:mm');
};

export const getDateTimeFromUtcInLocalTime = (date, user) => {
    if (!date) {
        return '';
    }

    return Moment.utc(date).tz(user && user['Timezone']).format(process.env.DATE_FORMAT + ' HH:mm');
};

export const getDateTimeUTC = (date, timezone, asMomentDate=false) => {
    if (!date) {
        return undefined;
    }

    const momentDate = Moment.tz(date, POSSIBLE_DATETIME_FORMATS, timezone);
    if (asMomentDate) {
        return momentDate;
    }

    return momentDate.format();
}

export const getObjectValue = (base, fields) => {
    if (!_.isString(fields)) {
        return base;
    }

    if (!base) {
        return undefined;
    }

    fields = fields.split('.');
    let result = base;
    for (let i = 0; i < fields.length; i++) {
        if (result === undefined || result === null) {
            break;
        }

        result = result[fields[i]];
    }

    return result;
};

export const isAdmin = (user) => {
    if (_.isObject(user)) {
        return (user && user.id === 1);

    } else {
        return user === 1;
    }
};

// Normalizes an arbitrary date input into a canonical ISO-8601 string, or null
// if it isn't a valid date. The returned value is always Moment's own
// toISOString() output (no quotes/control chars possible), so it is safe to
// embed in SQL even though the source may be attacker-controlled.
export const toSafeIsoDate = (value) => {
    if (value === undefined || value === null || value === '') {
        return null;
    }

    const m = Moment(value);
    return m.isValid() ? m.toISOString() : null;
};

export const getOwnerId = (user) => {
    if (!user) {
        return undefined;
    }

    if (user.owner_id === 0) {
        return user.id;

    } else {
        return user.owner_id;
    }
};


export const getCaseAssignedToId = (currentCase) => {
    return currentCase && currentCase.intake && currentCase.intake['AssignedTo'];
}

export const getTaskAssignedToId = (task) => {
    return task && task['AssignedTo'];
}

export const getAssignedToFullName = (id, loggedIn = {}, employees = []) => {
    id = parseInt(id, 10);
    if (loggedIn.id === id) {
        return getFullName(loggedIn);
    }

    const user = employees.find(e => e.id === id);
    if (user) {
        return getFullName(user);
    }

    return undefined;
}

export const extractFields = (configWorkflow, currentCase, fieldType) => {
    let fields = [];
    if (!configWorkflow) {
        return [];
    }

    for (let i = 0; i < configWorkflow.length; i++) {
        let workflow = configWorkflow[i];
        if (workflow.type !== currentCase['CaseType']) {
            continue;
        }

        if (workflow && workflow.tables) {
            for (let k = 0; k < workflow.tables.length; k++) {
                let targetTable = workflow.tables[k];
                for (let j = 0; j < targetTable.fields.length; j++) {
                    let currentField = targetTable.fields[j];
                    if (currentField.type !== fieldType) {
                        continue;
                    }

                    let index = fields.findIndex(field => {
                        return field.name === currentField.name &&
                               field['$TableName$'] == targetTable.table &&
                               field['$Type$'] == currentField.type;
                    });

                    if (index < 0) {
                        let field = {...currentField};
                        field['$TableName$'] = targetTable.table;
                        field['$Type$'] = currentField.type;
                        fields.push(field);
                    }
                }
            }
        }
    }

    return fields;
}

export const getSectionsFromFields = (fieldsMap, defaultFirstSeparator, fieldErrors) => {
    if (!fieldsMap || fieldsMap.length === 0) {
        return undefined;
    }

    const sections = [];
    if (fieldsMap[0].type === 'Separator') {
        sections.push({
            label: fieldsMap[0].props.label,
            fields: [],
            errors: [],
        })
    } else {
        sections.push({
            label: defaultFirstSeparator,
            fields: [{ ...fieldsMap[0] }],
            errors: [],
        });
    }

    for (let i = 1; i < fieldsMap.length; i++) {
        const field = fieldsMap[i];
        if (field.type === 'Separator') {
            sections.push({
                label: field.props.label,
                fields: [],
                errors: [],
            });
        } else {
            sections[sections.length - 1].fields.push(field);
            if (fieldErrors && !isEmptyObject(fieldErrors[field.name])) {
                sections[sections.length - 1].errors.push({
                    ...fieldErrors[field]
                });
            }
        }
    }

    return sections;
};

export const extractFieldsOptions = (config, currentCase, fieldType) => {
    let options = [];
    if (isEmptyObject(currentCase) || isEmptyObject(config)) {
        return options;
    }

    let optionFields = extractFields(config.workflow, currentCase, fieldType);
    for (let i = 0; i < optionFields.length; i++) {
        let field = optionFields[i];
        let fieldValue = currentCase[field['$TableName$']][field.name];
        if (!fieldValue) {
            continue;
        }

        if (field['$TableName$'] === 'client') {
            options.push({
                ...field,
                'label': `${field.props.label}: ${fieldValue}`,
                'value': fieldValue
            });

        } else {
            options.push({
                ...field,
                'label': `${field.props.label}: ${fieldValue}`,
                'value': fieldValue
            });
        }
    }

    options.sort((a,b) => {
        if (a['$TableName$'] === 'client' && b['$TableName$'] !== 'client') {
            return 1;

        } else if (a['$TableName$'] !== 'client' && b['$TableName$'] === 'client') {
            return -1;
        }

        let keyA = `${a['$TableName$']}.${a['name']}`;
        let keyB = `${b['$TableName$']}.${b['name']}`;
        return keyA.localeCompare(keyB);
    });
   
    if (!config.client) {
        return options;
    }

    let caseContactFields = extractFields(config.workflow, currentCase, 'Contact');
    for (let i = 0; i < caseContactFields.length; i++) {
        let field = caseContactFields[i];
        let contact = {};
        try {
            contact = JSON.parse(currentCase[field['$TableName$']][field.name]);

        } catch (e) {
            // Ignore string values and empty strings.
            continue;
        }

        if (isEmptyObject(contact)) {
            continue;
        }

        let clientConfig = config.client.find(value => {
            return value.type === contact['ClientType'];
        });

        if (!clientConfig || !clientConfig.tables) {
            console.error('Unknown client config: ' + contact['ClientType']);
            continue;
        }

        let clientConfigFields = clientConfig.tables[0].fields;
        for (let j = 0; j < clientConfigFields.length; j++) {
            if (clientConfigFields[j].type !== fieldType) {
                continue;
            }

            let fieldName = clientConfigFields[j].name;
            if (!isEmptyString(contact[fieldName])) {
                options.push({
                    ...field,
                    'label': `${transformTextFromPlaceholderMapping(field.props.clientLabel, contact)}: ${contact[fieldName]}`,
                    'value': contact[fieldName]
                });
            }
        }
    }

    return options;
}


export const extractCaseTypeTasks = (configWorkflow, currentCase) => {
    if (!configWorkflow || !currentCase) {
        return undefined;
    }

    for (let i = 0; i < configWorkflow.length; i++) {
        let workflow = configWorkflow[i];
        if (workflow.type !== currentCase['CaseType'] && workflow.type !== currentCase.intake['CaseType']) {
            continue;
        }

        return workflow.tasklist || [];
    }

    return undefined;
};


export const maybeSerializedJson = (str) => {
    return !isEmptyString(str) && ((str.length > 2 && str[0] === '{') || (str === '{}'));
};


export const dateSort = (dateA, dateB, tie = undefined) => {
    if (dateA !== undefined && dateB === undefined) {
        return -1;
    }

    if (dateA === undefined && dateB !== undefined) {
        return 1;
    }

    if (dateA === undefined && dateB === undefined) {
        return 0;
    }

    dateA = Moment.utc(dateA);
    dateB = Moment.utc(dateB);
    if (dateA.isValid() && !dateB.isValid()) {
        return 1;
    }

    if (!dateA.isValid() && dateB.isValid()) {
        return -1;
    }

    if (!dateA.isValid() && !dateB.isValid()) {
        return 0;
    }

    if (dateA.isSame(dateB)) {
        if (_.isFunction(tie)) {
            return tie(dateA, dateB);
        }

        return 0;
    }

    if (dateA.isAfter(dateB)) {
        return -1;
    }

    return 1;
}


export const integerSort = (intA, intB) => {
    if (intA !== undefined && intB === undefined) {
        return -1;
    }

    if (intA === undefined && intB !== undefined) {
        return 1;
    }

    if (intA === undefined && intB === undefined) {
        return 0;
    }

    intA = parseInt(intA, 10);
    intB = parseInt(intB, 10);
    return intB - intA;
}


export const floatSort = (floatA, floatB) => {
    if (floatA !== undefined && floatB === undefined) {
        return -1;
    }

    if (floatA === undefined && floatB !== undefined) {
        return 1;
    }

    if (floatA === undefined && floatB === undefined) {
        return 0;
    }

    floatA = parseFloat(floatA, 10);
    floatB = parseFloat(floatB, 10);
    return floatB - floatA;
}

export const isDateOlderThan = (dateUtc, amount, unit) => {
    const date = Moment.utc(dateUtc);
    const threshold = Moment.utc().subtract(amount, unit);
    return date.isSameOrAfter(threshold);
}

export const filterTasks = (tasks, caseId = undefined, blockedByFilter = true) => {
    if (caseId && !_.isArray(caseId)) {
        caseId = [caseId];
    }

    if (tasks) {
        let filteredTasks = tasks.filter(task => {
            if (caseId && (!task['CaseId'] || !caseId.find(id => id === task['CaseId']))) {
                return false;
            }

            if (blockedByFilter && task['BlockedBy']) {
                let blockedBy = tasks.find(t => {return t.id == task['BlockedBy']});
                if (blockedBy && !blockedBy['Completed']) {
                    return false;
                }
            }

            return true;
        });

        return filteredTasks;
    }

    return tasks;
}

export const findBootstrapEnvironment = () => {
    let envs = ['xs', 'sm', 'md', 'lg'];

    let $el = $('<div>');
    $el.appendTo($('body'));

    for (let i = envs.length - 1; i >= 0; i--) {
        let env = envs[i];

        $el.addClass('hidden-'+env);
        if ($el.is(':hidden')) {
            $el.remove();
            return env;
        }
    }

    return '';
}

export const updateTask = (task, props, success, failure) => {
    props.dispatch(userTaskUpdateAction(task))
        .then(result => {
            if (isEmptyObject(result.data)) {
                failure("Empty result.");
                return;
            }

            if (!task['ActionPerformed'] && result.data.updatedTasks[0]['ActionPerformed']) {
                props.dispatch(caseRefreshAction(task['CaseId']))
                    .then(result => {
                        if (isEmptyObject(result.data)) {
                            failure("Empty result (updating case)");
                            return;
                        }
    
                        success(result);
                    })
                    .catch(error => {
                        failure(error);
                    });
    
            } else {
                success(result);
            }
        })
        .catch(error => {
            failure(error);
        });
}

export const getUrlVars = () => {
    let vars = []
    let hash;
    let hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for (let i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }

    return vars;
}


export const numberWithCommas = (x) => {
    if (!x) {
        return '';
    }

    let parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
}


export const getDownloadPath = (caseId, fileName, subfolder = 'notes') => {
    return `/api/v1/download/case/${caseId}/${subfolder}/${encodeURIComponent(fileName)}`;
};

export const createBlob = (parts, properties) => {
    parts = parts || [];
    properties = properties || {};
    if (typeof properties === 'string') {
        properties = { type: properties }; // infer content type
    }
    try {
        return new Blob(parts, properties);
    }
    catch (e) {
        if (e.name !== 'TypeError' && e.name !== 'InvalidStateError') {
            throw e;
        }
        var Builder = typeof BlobBuilder !== 'undefined'
            ? BlobBuilder : typeof MSBlobBuilder !== 'undefined'
            ? MSBlobBuilder : typeof MozBlobBuilder !== 'undefined'
            ? MozBlobBuilder : WebKitBlobBuilder;
        var builder = new Builder();
        for (var i = 0; i < parts.length; i += 1) {
            builder.append(parts[i]);
        }
        return builder.getBlob(properties.type);
    }
};


export const downloadCsv = (headers, rows, fileName, table=undefined) => {
    let csvContent = 'ID {id}';
    for (let i = 0; i < headers.length; i += 1) {
        const header = headers[i];
        csvContent += ',';
        let placeholder = header.table || '';
        if (placeholder.length > 0) {
            placeholder += '.';
        }

        placeholder += header.name;
        csvContent += `"${header.label} {${placeholder}}"`;
    }

    csvContent += '\r\n';
    rows.forEach((row) => {
        csvContent += row['id'] || (table && row[table]['id']) || '';
        for (let i = 0; i < headers.length; i += 1) {
            csvContent += ',';
            let value = row[headers[i].table || table][headers[i].name];
            if (maybeSerializedJson(value)) {
                let obj;
                try {
                    obj = JSON.parse(value);
                } catch(e) {}

                value = obj['$Label$'];
            } 
            
            if (isEmptyString(value)) {
                value = '';
            }

            value = value + '';
            csvContent += `"${value.replace(/"/g, "'")}"`;
        }

        csvContent += '\r\n';
    });

    const encodedUri = 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURIComponent(csvContent);
    const link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
};

export const loadAction = (searchRequest, query, filter, archived) => {
    let first = true;
    if (query) {
        searchRequest += '?';
        first = false;
        searchRequest += 'q=' + encodeURIComponent(query);
    }

    if (filter) {
        if (first) {
            searchRequest += '?';
            first = false;

        } else {
            searchRequest += '&';
        }

        searchRequest += 'f=' + encodeURIComponent(filter);
    }

    if (archived) {
        if (first) {
            searchRequest += '?';
            first = false;

        } else {
            searchRequest += '&';
        }

        searchRequest += 'a=' + encodeURIComponent(archived);
    }

    return searchRequest;
};

export const getHostname = (url) => {
    const link = document.createElement('a');
    link.setAttribute('href', encodeURI(url));
    return link.hostname;
};

export const stripHtml = (html) => {
   var tmp = document.createElement('div');
   tmp.innerHTML = html;
   return tmp.textContent || tmp.innerText || "";
};

export const filterNonAsciiCharacters = (text) => {
    return text.replace(/[^\x00-\x7F]/g, "");
};

export const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return '0';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    //const i = Math.floor(Math.log(bytes) / Math.log(k));
    const i = 1; // Sorting in table works now only for the same units.

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

export const navigateToCase = (dispatch, caseId, initialCase = {}) => {
    const id = parseInt(caseId, 10);
    dispatch(caseEditIdAction(id, initialCase));
    $('html, body').animate({
        scrollTop: $('#mainNavBar').offset().top
    }, 0);

    browserHistory.push(`/case/edit/intake/${id}`);
};


export const isTest = () => {
    return process.env.JEST_WORKER_ID !== undefined;
};

export const getPdfPagesNumber = (async function(pdfFilePath) {
    const doc = await pdfjsLib.getDocument(pdfFilePath);
    return doc.numPages;
});


export const getContactFieldsMapFromConfig = (currentConfig, caseType = undefined) => {
    if (!currentConfig || !currentConfig['client']) {
        return {};
    }

    const fieldsMap = {};
    currentConfig['client'].forEach(source => {
        const type = source.type;
        const targetTable = source.tables.find(t => t['table'] === 'client');
        fieldsMap[type] = _.cloneDeep(targetTable.fields);
    });

    if (caseType && fieldsMap['Client']) {
        fieldsMap['Client'] = fieldsMap['Client'].filter(field => _.intersectionBy(['ALL', caseType], field.visibility).length > 0);
    }

    return fieldsMap;
};

export const getWordPlaceholders = (arrayBuffer) => {
    const iModule = new InspectModule();
    const zip = new JSZip(arrayBuffer);
    const docx = new Docxtemplater().loadZip(zip).attachModule(iModule);
    docx.compile();
    const placeholders = iModule.getAllTags();
    return placeholders;
}

export const getSignaturePlaceholders = (placeholders) => {
    const signature_placeholders = [];
    const duplicates = {};
    for (let p in placeholders) {
        if (!isPlaceholderSignature(p)) {
            continue;
        }

        if (p.endsWith('DateTime')) {
            p = p.substring(0, p.length - 8);
        }

        p = p.substring(p.startsWith('%') ? 1 : 0);
        if (duplicates[p]) {
            continue;
        }

        signature_placeholders.push(p);
        duplicates[p] = true;
    }

    return signature_placeholders;
}


export const isPlaceholderSignature = (placeholder) => {
    return placeholder.startsWith('%docs.Signature') || placeholder.startsWith('%payment.ClientSignature') ||
           placeholder.startsWith('docs.Signature') || placeholder.startsWith('payment.ClientSignature');
};


export const hasSignaturePlaceholders = (placeholders = {}) => {
    return getSignaturePlaceholders(placeholders).length > 0;
}

export const getFilledPlaceholers = (placeholders, matter, config) => {
    if (!placeholders || !matter) {
        return placeholders;
    }

    const data = getWorkflowTranslationHashTable(config, matter);
    const result = {};
    Object.keys(placeholders).forEach(p => {
        if (p.startsWith('%')) {
            p = p.substr(1);
        }

        if (data[p]) {
            result[p] = data[p];
        } else {
            result[p] = '';
        }
    });

    return result;
}

export const getFormEditorSuggestionFieldsArrayFromConfig = (currentConfig, configSource = 'workflow', prependTableName = true, filter = (type, table, fields) => true) => {
    const fieldsMap = [];
    if (!currentConfig) {
        return fieldsMap;
    }


    const fieldsSource = currentConfig[configSource];
    if (!fieldsSource) {
        return fieldsMap;
    }

    const names = new Set();
    for (let i = 0; i < fieldsSource.length; i++) {
        const type = fieldsSource[i].type;
        if (!filter(type, undefined, undefined)) {
            continue;
        }

        const tables = fieldsSource[i].tables;
        for (let j = 0; j < tables.length; j++) {
            const table = tables[j].table;
            const fields = tables[j].fields;
            if (!filter(type, table, undefined)) {
                continue;
            }

            for (let k = 0; k < fields.length; k++) {
                const field = {...fields[k]};
                let name = field.name;
                if (prependTableName) {
                    name = `${table}.${field.name}`;
                    field.name = name;
                }

                if (names.has(name)) {
                    continue;
                }

                if (!filter(type, table, field)) {
                    continue;
                }

                names.add(name);
                fieldsMap.push(_.cloneDeep(field));
            }
        }
    }

    fieldsMap.sort((a,b) => a.props.label.localeCompare(b.props.label));
    return fieldsMap;
}

export const getPaymentAccount = (owner) => {
    let account;
    let accountType = 'None';
    if (owner) {
        if (!isEmptyObject(owner['LawPayAccount'])) {
            account = owner['LawPayAccount'];
            accountType = 'LawPay';
        } else if (owner['PayPalAccount']) {
            account = owner['PayPalAccount'];
            accountType = 'PayPal';
        }
    }

    return {accountType, account};
}

export const isEvenPartOfInvoice = (event = {}) => {
    const invoiceIds = event['$InvoiceId$'];
    if (!invoiceIds) {
        return false;
    }
    if (_.isObject(invoiceIds)) {
        return Object.keys(invoiceIds).sort().filter(i => i > 0).length > 0;
    } else {
        return !!invoiceIds;
    }
}
